import React, { useState, useEffect, useContext } from "react";
import { LocalesProvider, LocalesContext } from "./contexts/LocalesContext";
import MapComponent from "./components/MapComponent";
import SessionInfosComponent from "./components/SessionInfosComponent";

function MiplusSessionMain(props) {
  const { session } = props;
  const unitsSystem = props.units_system;
  const {
    t,
    translations,
    actions: localesActions,
  } = useContext(LocalesContext);

  // EFFECTS ******************************************************************

  useEffect(() => {
    localesActions.setLocale(props.locale);
    localesActions.setTranslations(props.translations);
  }, []);

  // RENDER ******************************************************************

  return (
    <div className="c-content__body">
        <div className="row">
        <div className="col-5">
            <SessionInfosComponent 
              session={props.session} 
              unitsSystem={unitsSystem} 
              user={props.user}
              stats={props.stats}
            />
        </div>
        <div className="col-4 col--stretch">
            <MapComponent coords={session?.params?.coords} />
        </div>
        </div>
    </div>
  );
}

export default (props) => {
  return (
    <LocalesProvider>
      <MiplusSessionMain {...props} />
    </LocalesProvider>
  );
};